import { render, staticRenderFns } from "./NflSavedLineup.vue?vue&type=template&id=2208e1e9&scoped=true"
import script from "./NflSavedLineup.vue?vue&type=script&lang=js"
export * from "./NflSavedLineup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208e1e9",
  null
  
)

export default component.exports